module.exports = __webpack_public_path__ + "static/media/category-filled-in.cc9f5936.png";